import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const CALENDLY_URL = 'https://calendly.com/contact-bankkimedia/30min';

const CtaBanner = ({ text, buttonText, subtext }) => (
  <section className="py-10 md:py-14 border-t border-white/5">
    <div className="container-custom max-w-3xl text-center">
      <p className="text-white text-xl md:text-2xl font-bold font-['Syne'] mb-4">{text}</p>
      <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
        <motion.span whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }} className="inline-flex items-center gap-2 px-8 py-3.5 bg-[#c8ff00] text-black font-bold rounded-full hover:bg-[#d4ff33] transition-colors">
          {buttonText}
          <ArrowRight className="w-4 h-4" />
        </motion.span>
      </a>
      {subtext && <p className="text-white/30 text-sm mt-3">{subtext}</p>}
    </div>
  </section>
);

export default CtaBanner;
